export default __webpack_public_path__ + "3b758ab30f0db2e62dd0abe5896b5490.png";